export default {
    requestType: "Remove Vehicle",
    policyUserId: "",
    policyNumber: "",
    effectiveDate: "",
    expirationDate: "",
    firstName: "",
    middleInitial: "",
    lastName: "",
    emailAddress: "",
    policyState: "",
    vehicles: {
        vehiclesOnPolicy: {
            storedVehicles: [],
            newVehicles: [],
            removedVehicles: []
        }
    },
    driversHHMs: {
        drivers: {
            pendingNewDrivers: [],
            pendingRemovedDrivers: [],
            storedDrivers: [],
            newDrivers: []
        },
        householdMembers: {
            pendingNewMembers: [],
            pendingRemovedMembers: [],
            storedMembers: [],
            newMembers: []
        }
    },
    driverAssignment: {},
    confirmation: false
}